import { render, staticRenderFns } from "./current-residence.vue?vue&type=template&id=1c77859e&scoped=true&"
import script from "./current-residence.vue?vue&type=script&lang=js&"
export * from "./current-residence.vue?vue&type=script&lang=js&"
import style0 from "./current-residence.vue?vue&type=style&index=0&id=1c77859e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c77859e",
  null
  
)

export default component.exports